const PipeElement = () => <div className="opacity-25 px-2">|</div>;
export default PipeElement;
